module.exports = __webpack_public_path__ + "static/media/about-footer.2be9602f.jpg";